import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoggedOut.css";

const LoggedOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      navigate("/auth", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div className="loggedout-outer">
      <div className="loggedout-box">
        <div className="loggedout-logo">
          <h1>Wallet UI</h1>
        </div>
        <div className="loggedout-gap" />
        <div className="loggedout-tick">✓</div>
        <p className="loggedout-message">
          You have been successfully logged out.
        </p>
        <button
          className="loggedout-signin-btn"
          onClick={() => navigate("/auth")}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
};

export default LoggedOut;
